import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { FormikProps } from 'formik';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';

import { ContentInput } from 'api';
import { Loaders } from 'components';

import { ExternalShareOption, ExternalSharePostSchema, usePostContext } from 'features/postingV2';
import { ExternalSharingSchema } from 'features/sharing/validations';
import { IShare } from '../../types';

interface IProps {
  loading: boolean;
  onSubmit: () => void;
  postingFormikBag: FormikProps<ContentInput>;
  sharingFormikBag: FormikProps<IShare>;
}

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 4,
    marginLeft: theme.spacing(2),
    width: 100,
  },
}));

const FormButtons: FC<IProps> = ({ loading, onSubmit, postingFormikBag, sharingFormikBag }) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const { state } = usePostContext();

  const postValues = postingFormikBag.values;
  const shareValues = sharingFormikBag.values;

  const isPostValid = ExternalSharePostSchema.isValidSync(postValues, {
    uiState: state,
  });
  const isShareValid = ExternalSharingSchema.isValidSync(shareValues) && hasCommentary();

  function hasCommentary() {
    if (state.shareOption !== ExternalShareOption.TextShare) {
      return true;
    }

    return !!(
      get(shareValues, 'twitter.user_commentary') ||
      get(shareValues, 'linkedin.user_commentary') ||
      get(shareValues, 'facebook.user_commentary')
    );
  }

  if (loading) {
    return (
      <Grid item xs container justify="flex-end">
        <Grid item>
          <Loaders.Standard height={38} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container justify="flex-end">
      <Grid item>
        <Button
          className={classes.button}
          variant="outlined"
          size="large"
          onClick={() => history.goBack()}>
          {t('common:cancel')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          className={classes.button}
          color="primary"
          variant="contained"
          size="large"
          disabled={!isPostValid || !isShareValid}
          onClick={onSubmit}>
          {t('common:share')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default FormButtons;
